import { columns } from './manageInvitationKeysPanel/utility/getColumns';
import { useManageInvitationKeys } from './manageInvitationKeysPanel/utility/useManageInvitationKeys';
import { getAttr } from '../../../../../features/helpers/apiHelpers';
import { InviteePanel } from '../../../../../components/InviteePanel';

const ManageInvitationKeysPanel = ({
  selectedInvitationGroupKey,
  allInvitationGroups,
  allInvitationKeys,
}) => {
  const mangageInvitationKeysData = useManageInvitationKeys(
    selectedInvitationGroupKey,
    allInvitationGroups,
    allInvitationKeys,
  );

  return (
    <InviteePanel
      {...mangageInvitationKeysData}
      showGroupName={!!mangageInvitationKeysData.selectedGroup}
      groupName={
        mangageInvitationKeysData.selectedGroup
          ? getAttr(mangageInvitationKeysData.selectedGroup, 'name')
          : null
      }
      getColumns={columns}
    />
  );
};

export { ManageInvitationKeysPanel };
